// @flow
let account = 'https://tuic-kundenkonto.dev.jakala.services';
if (window.location.href.indexOf('http://local.dev.jakala.services') >= 0) {
  account = 'http://tuic-mr-local.dev.jakala.services:9001';
}

export default {
  trackingCode: 'qa', //'UA-6438006-17',
  cookieDomain: '.jakala.services',
  logoutURL: 'https://tuic-mrl.dev.jakala.services/login',
  account,
  accountLogin: `${account}/signin`,
  accountRegister: `${account}/signin/registration`,
  excursionMultiSelectCacheKey: 'travelPartyState',
  iadvizeId: '6761',
};
